interface Props {
  activeColor?: string;
  bgColor?: string;
}

const InProgressLeadsIcon = ({ activeColor, bgColor }: Props) => {
  const fillColor = activeColor || "#7e22ce";
  const bgFillColor = bgColor || "#f3e8ff";

  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="22" fill={bgFillColor} />

      <circle cx="24" cy="24" r="13" stroke="#7e22ce" strokeWidth="2.75" />

      <path
        d="M24 17.5V24H30.5"
        stroke="#7e22ce"
        strokeWidth="2.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InProgressLeadsIcon;
